import {Characteristic, BleError, Subscription} from 'react-native-ble-plx';
import EventEmitter from 'events';
import Events from 'src/logging/Events';
import {generateErrorMessage} from 'src/logging/generateErrorMessage';
import CrashlyticsEvents from 'src/logging/Crashlytics';

export const PaymentNotifyEvents = {
  updated: 'updated',
};
export default class PaymentNotifyCharacteristic extends EventEmitter {
  monitorSubscription: Subscription;

  constructor(characteristic: Characteristic) {
    super();
    this.characteristicChanged = this.characteristicChanged.bind(this);

    if (characteristic.isNotifiable) {
      this.monitorSubscription = characteristic.monitor(
        this.characteristicChanged,
      );
    }
  }

  deregister() {
    this.monitorSubscription.remove();
  }

  characteristicChanged(
    error: BleError | null,
    characteristic: Characteristic | null,
  ) {
    if (error) {
      CrashlyticsEvents.log(
        'Warning',
        'PaymentNotifyCharacteristic:characteristicChanged',
        generateErrorMessage(error),
      );
      Events.Error.trackEvent(
        'Warning',
        'PaymentNotifyCharacteristic:characteristicChanged',
        generateErrorMessage(error),
      );
    }

    if (characteristic) {
      this.emit(PaymentNotifyEvents.updated, characteristic.value);
    }
  }
}
